<template>
  <div></div>
</template>

<script>
import {ebus} from "@/vendor/ebus";
import store from "../store/store";
import {triggerSwDestroy} from "../util/globalErrorHandler";
import {clearEvents, cloneMe} from "../vendor/util";


export default {
  name: 'AndroidKioskLifecycle',

  created() {
    ebus.$on('postToWindowskiosk', (obj) => {
      // this.log('postToWindowskiosk received...');
      if (!store.getters.isAndroidKiosk) {
        return;
      }
      this.$nextTick(() => {
        this.invokeAndroidKiosk(obj);
      });
    });

    ebus.$on('releaseTerminal', () => {
      this.releaseTerminal();
    });

    ebus.$on('doExitKiosk', () => {
      this.doExitKiosk();
    });

    ebus.$on('getAndroidBluetoothDevices', () => {
      this.getBluetoothDevices();
    });

    ebus.$on('getAndroidAllPaymentStores', () => {
      this.getAllPaymentStores();
    });

    ebus.$on('getKioskUrl', () => {
      this.getKioskUrl();
    });
    ebus.$on('saveKioskUrl', (url) => {
      this.saveKioskUrl(url);
    });

    ebus.$on('getAndroidJsonAppConfig', () => {
      this.getAndroidJsonAppConfig();
    });
    ebus.$on('setAndroidJsonAppConfig', (json) => {
      this.setAndroidJsonAppConfig(json);
    });

    ebus.$on('getSoftposTerminalState', () => {
      this.getSoftposTerminalState();
    });

    ebus.$on('getStorePicked', () => {
      this.getStorePicked();
    });

  },

  mounted() {
    this.getKioskBridge();
    this.initKioskMode();
  },

  destroyed() {
    clearEvents([
      'postToWindowskiosk',
      'cb-postToWindowskiosk',
      'releaseTerminal',
      'doExitKiosk',
      'getAndroidBluetoothDevices',
      'getAndroidAllPaymentStores',
      'getKioskUrl',
      'saveKioskUrl',
      'getAndroidJsonAppConfig',
      'setAndroidJsonAppConfig',
      'getSoftposTerminalState',
      'getStorePicked',
    ]);
  },

  methods: {
    log(t, o) {
      if (o) {
        console.log('AndroidKioskLifecycle: ' + t, o);
      } else {
        console.log('AndroidKioskLifecycle: ' + t);
      }
    },
    async invokeAndroidKiosk(params) {
      try {
        const action = params.action
        if (action !== 'readStatusFromTerminal') {
          this.log("invokeAndroidKiosk... for action " + action);
        }

        const PrinterPlugin = window.Capacitor.Plugins.PrinterPlugin;
        const PaymentPlugin = window.Capacitor.Plugins.PaymentPlugin;

        if (action === 'dummyPrint') {
          this.log('PrinterPlugin.dummyPrint()...');
          const result = await PrinterPlugin.dummyPrint();
        } else if (action === 'getPrinterLog') {
          await this.getAndroidPrinterLog(PrinterPlugin);
        } else if (action === 'triggerBonPrintOrder') {
          this.log('PrinterPlugin.triggerBonPrintOrder()...');
          const result = await PrinterPlugin.triggerBonPrintOrder({
            bridgeRequest: JSON.stringify(params),
          });
        } else if (action === 'triggerPosTerminal') {
          this.log('PaymentPlugin.triggerPosTerminal()...');
          const result = await PaymentPlugin.triggerPosTerminal({
            bridgeRequest: JSON.stringify(params),
          });
          result.action = action;
          if (result.paymentTxEnded) {
            //we know that this must be an error case, i.e. Terminal is not ready
          }
          ebus.$emit('cb-postToWindowskiosk', cloneMe(result));
        } else if (action === 'checkTerminalServiceActive') {
          this.log('PaymentPlugin.checkTerminalServiceActive()...');
          const result = await PaymentPlugin.checkTerminalServiceActive({
            bridgeRequest: JSON.stringify({}),
          });
          result.action = action;
          ebus.$emit('cb-postToWindowskiosk', cloneMe(result));
        } else if (action === 'readStatusFromTerminal') {
          const result = await PaymentPlugin.readStatusFromTerminal({
            bridgeRequest: JSON.stringify({}),
          });
          result.action = action;
          if (result.paymentTxEnded) {
            this.log('readStatusFromTerminal finished with paymentTxEnded=true. paymentResult= ' + result.paymentResult);
            ebus.$emit('cb-postToWindowskiosk', cloneMe(result));
          }
        } else {
          this.log('invokeAndroidKiosk: ignore action ' + action);
        }
      } catch (e) {
        this.log("error in invokeAndroidKiosk: " + e.message, params);
      }
    },

    async getSoftposTerminalState() {
      this.log("getSoftposTerminalState...");
      const PaymentPlugin = window.Capacitor.Plugins.PaymentPlugin;
      const result = await PaymentPlugin.getSoftposTerminalState();

      this.log("Empfangener Wert aus getSoftposTerminalState:", JSON.stringify(result));

      if (result?.softposTerminalState?.length) {
        store.commit('softposTerminalState', '' + result.softposTerminalState);
      }
    },

    async getStorePicked() {
      this.log("getStorePicked...");
      const PaymentPlugin = window.Capacitor.Plugins.PaymentPlugin;
      const result = await PaymentPlugin.getStorePicked();

      this.log("Empfangener Wert aus getStorePicked:", JSON.stringify(result));

      if (result?.storeId?.length) {
        store.commit('storePicked', cloneMe(result));
      }
    },

    async getAndroidJsonAppConfig() {
      try {
        this.log("getAndroidJsonAppConfig...");

        const KioskSettings = window.Capacitor.Plugins.KioskSettings;
        const result = await KioskSettings.getJsonAppConfig();

        this.log("Empfangener Wert aus getJsonAppConfig:", result);

        if (result?.jsonAppConfig?.length) {
          store.commit('androidJsonAppConfig', '' + result.jsonAppConfig);
        }

      } catch (e) {
        this.log("error in getAndroidJsonAppConfig: ", e);
      }
    },

    async setAndroidJsonAppConfig(jsonConfig) {
      try {
        this.log("setAndroidJsonAppConfig... for jsonConfig " + jsonConfig);

        const KioskSettings = window.Capacitor.Plugins.KioskSettings;
        const result = await KioskSettings.setJsonAppConfig({
          bridgeRequest: jsonConfig
        });

        this.log("Empfangener Wert aus setAndroidJsonAppConfig:", result);

        if (result?.ok) {
          ebus.$emit('toast', 'App Config erfolgreich gespeichert');
        } else {
          ebus.$emit('showInfo', {
            title: 'Fehler bei der Speicherung der App Config',
            text: 'Bitte überprüfe die JSON Syntax. Hinweis: ' + result.errorHint
          });
        }

      } catch (e) {
        this.log("error in setAndroidJsonAppConfig: ", e);
      }
    },

    async getAndroidPrinterLog(PrinterPlugin) {
      try {
        this.log("getAndroidPrinterLog...");

        const result = await PrinterPlugin.getAndroidPrinterLog();

        this.log("Empfangenes result aus getAndroidPrinterLog:", result);

        if (result?.printerLog?.length) {
          store.commit('printerLog', '' + result.printerLog);
        }
      } catch (e) {
        this.log("error in getAndroidPrinterLog: ", e);
      }
    },

    async getBluetoothDevices() {
      try {
        this.log("getBluetoothDevices...");

        const PrinterPlugin = window.Capacitor.Plugins.PrinterPlugin;
        const result = await PrinterPlugin.getBluetoothDevices();

        this.log("Empfangenes result aus bluetoothDevices:", result);

        if (result?.devices?.length) {
          store.commit('bluetoothDevices', '' + result.devices);
        } else {
          store.commit('bluetoothDevices', '[]');
        }
      } catch (e) {
        this.log("error in getBluetoothDevices: ", e);
      }
    },

    async getAllPaymentStores() {
      try {
        this.log("getAllStores...");

        const PaymentPlugin = window.Capacitor.Plugins.PaymentPlugin;
        const result = await PaymentPlugin.getAllStores();

        this.log("Empfangenes result aus getAllStores:", result);

        if (result?.allStores) {
          const formattedStores = JSON.stringify(JSON.parse(result.allStores), null, 2);
          store.commit('allPaymentStores', '' + formattedStores);
        } else {
          store.commit('allPaymentStores', '[]');
        }
      } catch (e) {
        this.log("error in getBluetoothDevices: ", e);
      }
    },

    // async getSoftposStoreName() {
    //   try {
    //     this.log("getSoftposStoreName...");
    //
    //     const PaymentPlugin = window.Capacitor.Plugins.PaymentPlugin;
    //     const result = await PaymentPlugin.getSoftposStoreName();
    //
    //     this.log("Empfangenes result aus getSoftposStoreName:", result);
    //
    //     if (result?.storeName?.length) {
    //       store.commit('softposStoreName', '' + result.storeName);
    //     }
    //   } catch (e) {
    //     this.log("error in getSoftposStoreName: ", e);
    //   }
    // },

    // async setSoftposStoreName(storeName) {
    //   try {
    //     this.log("setSoftposStoreName...");
    //
    //     const PaymentPlugin = window.Capacitor.Plugins.PaymentPlugin;
    //     const json = JSON.stringify({storeName: storeName});
    //     const result = await PaymentPlugin.setSoftposStoreName({
    //       bridgeRequest: json
    //     });
    //
    //     this.log("Empfangener Wert aus setSoftposStoreName:", result);
    //
    //     if (result?.ok) {
    //       ebus.$emit('toast', 'Softpos Store Name erfolgreich gespeichert');
    //     } else {
    //       ebus.$emit('showInfo', {
    //         title: 'Fehler bei der Speicherung des Softpos Store Name',
    //       });
    //     }
    //   } catch (e) {
    //     this.log("error in setSoftposStoreName: ", e);
    //   }
    // },

    async getKioskUrl() {
      try {
        this.log("getKioskUrl...");

        const KioskSettings = window.Capacitor.Plugins.KioskSettings;
        const result = await KioskSettings.getServerBasePath();

        this.log("Empfangenes result aus androidKioskUrl:", result);

        if (result?.path?.length) {
          store.commit('androidKioskUrl', '' + result.path);
        }

        // 3. App neu laden, damit die MainActivity die neue URL greift
        // window.location.reload();
      } catch (e) {
        this.log("error in getKioskUrl: ", e);
      }
    },
    async saveKioskUrl(url) {
      try {
        try {
          triggerSwDestroy();
        } catch (e) {

        }

        // 1. Alle Service Worker deregistrieren
        if ('serviceWorker' in navigator) {
          const registrations = await navigator.serviceWorker.getRegistrations();
          for (let registration of registrations) {
            await registration.unregister();
            this.log("Service Worker entfernt");
          }
        }

        setTimeout(() => {
          const WebViewPlugin = window.Capacitor.Plugins.WebView;

          // 1. Die URL für die aktuelle Session setzen
          WebViewPlugin.setServerBasePath({path: url});

          // 2. Die URL dauerhaft im Android-System speichern (deine Methode!)
          WebViewPlugin.persistServerBasePath();

          this.log("saveKioskUrl succeeded for URL " + url);

          const KioskSettings = window.Capacitor.Plugins.KioskSettings;
          KioskSettings.rebootApp();

          // 3. Den WebView zwingen, die neue URL jetzt sofort zu laden
          // window.location.href löst den Reload mit dem neuen Basispfad aus
          // window.location.href = url;
        }, 3500);


      } catch (e) {
        this.log("error in saveKioskUrl: ", e);
      }
    },
    async getKioskBridge() {
      this.log('getKioskBridge...');

      // 1. Prüfen, ob Capacitor überhaupt verfügbar ist
      const isNative = window.Capacitor && window.Capacitor.isNativePlatform();

      if (isNative) {
        this.log("Läuft nativ auf:", window.Capacitor.getPlatform());

        // 2. Prüfen, ob unser Kiosk-Plugin geladen wurde
        const Kiosk = window.Capacitor.Plugins.Kiosk ||
          window.Capacitor.Plugins.CapacitorAndroidKiosk ||
          window.Capacitor.Plugins.CapacitorKiosk;
        store.commit('isAndroidKiosk', true);
        if (Kiosk) {

          return Kiosk;
        }
      } else {
        this.log('isNative=false');
      }
      this.log('Keine native bridge gefunden');
      return null;
    },

    async releaseTerminal() {
      const PaymentPlugin = window.Capacitor.Plugins.PaymentPlugin;
      PaymentPlugin.releaseTerminal();
    },

    async doExitKiosk() {
      this.log('doExitKiosk...');
      const Kiosk = await this.getKioskBridge();
      if (Kiosk) {
        // Hier feuern wir den Befehl zum Beenden des Kiosk-Modus
        try {
          await Kiosk.exitKioskMode();
          // Optional: App ganz schließen oder zum Launcher zurück
          this.log("Android Kiosk verlassen!");
        } catch (e) {
          this.log("Android Kiosk Exit fehlgeschlagen", e);
        }
        try {
          const KioskSettings = window.Capacitor.Plugins.KioskSettings;
          await KioskSettings.selfClose();
        } catch (e) {

        }
      } else {
        this.log("Android Kiosk nicht verfügbar");
      }
    },

    async initKioskMode() {
      this.log('initKioskMode...');

      try {
        // 1. Prüfen, ob Capacitor vom Android-Container bereitgestellt wurde
        if (window.Capacitor && window.Capacitor.Plugins) {
          this.log("Capacitor.Plugins is available");

          this.log("Verfügbare Plugins: " + Object.keys(window.Capacitor.Plugins).join(', '));

          const Kiosk = await this.getKioskBridge();

          if (Kiosk) {
            try {
              this.log('CapacitorAndroidKiosk ' + Kiosk, Kiosk);
              // 1. Berechtigungen anfragen
              // await Kiosk.requestPermissions();

              // 2. (Optional) Einmalig fragen, ob die App der Launcher sein soll
              // await Kiosk.setAsLauncher();

              // 2. Den Kiosk-Modus starten
              // setTimeout(()=>{
              //   Kiosk.enterKioskMode();
              this.log("Kiosk-Modus erfolgreich aktiviert");
              // },9000);

              this.log("Kiosk-Modus webApplicationLoadingFinished...");
              const KioskSettings = window.Capacitor.Plugins.KioskSettings;
              KioskSettings.webApplicationLoadingFinished()

              this.log("webApplicationLoadingFinished wurde aufgerufen");

            } catch (error) {
              this.log("Kiosk-Modus konnte nicht gestartet werden:", error);
            }
          } else {
            this.log("Capacitor Kiosk is not available");
          }

          // Beides komplett verstecken
          const SystemBars = window.Capacitor.Plugins.SystemBars
          if (SystemBars) {
            this.log('SystemBars ' + SystemBars, SystemBars);
            await SystemBars.hide();
          }

        } else {
          // Optionale Info für die Entwicklung im Browser
          this.log("Capacitor nicht gefunden. Läuft vermutlich im Desktop-Browser.");
        }
      } catch (e) {
        this.log("Error in initKioskMode: " + e.message);
      }
    },


  }

}


</script>


<style scoped lang="scss">

</style>
